module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "Joinbanner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "exampleTop"
  }, [_c('img', {
    staticClass: "example1Pic",
    attrs: {
      "src": require("../assets/x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "example1Word"
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统")])]), _vm._v(" "), _c('p', [_vm._v("面积1700平方，辐射周边人口20万人。主要问题：新开业，希望快速发展用户。客户对接好酷酷宝系统后，首先发挥开业期间都是爆满的。总结：酷酷宝的自bb ...")]), _c('span', [_vm._v("2016-11-17")])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "exampleTop"
  }, [_c('img', {
    staticClass: "example1Pic",
    attrs: {
      "src": require("../assets/x.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "example1Word"
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统")])]), _vm._v(" "), _c('p', [_vm._v("面积1700平方，辐射周边人口20万人。主要问题：新开业，希望快速发展用户。客户对接好酷酷宝系统后，首先发挥开业期间都是爆满的。总结：酷酷宝的自bb ...")]), _c('span', [_vm._v("2016-11-17")])])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "案例详情",
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/p23.jpg")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("吉林省游戏游艺设备认证系统解决方案")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MethodsBanner"
  }, [_c('img', {
    staticClass: "exampleWordPic",
    attrs: {
      "src": require("../assets/exampleWord.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-center-title"
  }, [_c('h4', [_vm._v("最新案例")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exampleBottom"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统解决方案啦啦...")]), _c('span', {
    staticClass: "date"
  }, [_vm._v("2016-11-17")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统解决方案啦啦...")]), _c('span', {
    staticClass: "date"
  }, [_vm._v("2016-11-17")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exampleBottom"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统解决方案啦啦...")]), _c('span', {
    staticClass: "date"
  }, [_vm._v("2016-11-17")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#example"
    }
  }, [_vm._v("吉林省游戏游艺设备认证系统解决方案啦啦...")]), _c('span', {
    staticClass: "date"
  }, [_vm._v("2016-11-17")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbbaf6fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/example.vue
// module id = 282
// module chunks = 1